import React from 'react';

const VERTEX_RADIUS = 4;
const VERTEX_HOVER_RADIUS = 7;
const TERMINAL_RADIUS = 3;

/** Render every vertex. Wired vertices take their electrical-node color;
 *  terminal-only vertices (no incident wires) render as small neutral dots. */
function Vertices({
  vertices,
  vertexNodeId,
  colorForNode,
  drawingFromVertexId,
  isSelected,
  hover,
  selectedTool,
  highlightedNodeId,
  onVertexMouseDown,
  hideVertexDots = false,
}) {
  return (
    <>
      {vertices.map((v) => {
        const isDrawingFrom = drawingFromVertexId === v.id;
        const vertexSelected = isSelected('wireVertex', v.id);
        const isHover = hover?.kind === 'vertex' && hover.id === v.id;
        const myNodeId = vertexNodeId.get(v.id);
        const isWired = myNodeId !== undefined;
        const isHighlighted = highlightedNodeId !== null && myNodeId === highlightedNodeId;
        const baseR = isWired ? VERTEX_RADIUS : TERMINAL_RADIUS;
        const r = isDrawingFrom || vertexSelected || isHover ? VERTEX_HOVER_RADIUS : baseR;
        const fill = isDrawingFrom
          ? 'var(--accent-amber)'
          : vertexSelected
            ? 'var(--accent-blue)'
            : isHover
              ? 'var(--accent-amber)'
              : isWired
                ? colorForNode(myNodeId)
                : 'var(--text-secondary)';
        const cursor = selectedTool ? 'pointer' : 'grab';
        // The toggle hides the static dot for wired vertices but
        // leaves interaction feedback intact: hover, selection,
        // drawing-from, and node-highlight all still light up so the
        // user sees what they're targeting. Terminal-only dots stay
        // because they identify component endpoints.
        const isInteracting =
          isDrawingFrom || vertexSelected || isHover || isHighlighted;
        const showDot = !hideVertexDots || !isWired || isInteracting;
        return (
          <g key={v.id}>
            <circle
              cx={v.x}
              cy={v.y}
              r={Math.max(r, 10)}
              fill="transparent"
              onMouseDown={onVertexMouseDown ? (e) => onVertexMouseDown(v.id, e) : undefined}
              style={{ cursor }}
            />
            {isHighlighted && isWired && (
              <circle
                cx={v.x}
                cy={v.y}
                r={r + 5}
                fill={colorForNode(myNodeId)}
                opacity={0.35}
                pointerEvents="none"
              />
            )}
            {showDot && (
              <circle cx={v.x} cy={v.y} r={r} fill={fill} pointerEvents="none" />
            )}
          </g>
        );
      })}
    </>
  );
}

export default React.memo(Vertices);
